import { Collection } from '@laminar-product/client-commons-core/core';
import api from 'api';

export const getCollection = async (collectionId: string) => {
  const { data } = await api().get<Collection>(`/collection/${collectionId}`);

  return data;
};
